import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const showApi = {
  detail (showSlug, params) {
    // let params = querystring..stringify(params)
    return axios.get(`${ApiSetting.baseUrl}/api/shows/${showSlug}/`, {params: params})
  },
  getPrices (showSlug, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/shows/${showSlug}/getprices/`, {params: params})
  }
}

export default showApi
